var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Link",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke-2870-+-Stroke-2871-+-Stroke-2872",
    transform: "translate(2.000000, 2.000000)",
    stroke: "#535455",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5238612,14.7512189 C17.735611,15.9632454 19.1256182,16.1549869 20.0289226,15.2518494 L25.9159237,9.36543581 C27.0846114,8.19746482 27.0846114,6.2860575 25.9159237,5.11808651 L22.6537129,1.85597806 C21.485526,0.688007062 19.5737654,0.688007062 18.4050777,1.85597806 L12.5180766,7.74239168 C11.6002513,8.65954678 11.819568,10.0477952 13.0187997,11.2468053",
    id: "Stroke-2870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5151844,13.7499579 C9.32696855,12.5619617 7.93796276,12.321659 7.01012292,13.2493274 L1.13163413,19.0786691 C-0.0415600145,20.2426351 -0.045565799,22.1500373 1.12262111,23.3180083 L4.45042661,26.6451987 C5.61861352,27.8131697 7.5263684,27.8086641 8.69004881,26.6361874 L14.5209689,20.7587851 C15.4382936,19.8411294 15.2199783,18.4538822 14.0202458,17.2543715",
    id: "Stroke-2871"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.51229212,
    y1: 19.2568936,
    x2: 18.5267534,
    y2: 9.24428323,
    id: "Stroke-2872"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.d07251ed.svg";
export { ForwardRef as ReactComponent };